import { Button, Popconfirm } from 'antd';
import { CopyOutlined, DeleteOutlined } from '@ant-design/icons';

import PrivateRouteConst from 'core/common/privateRouteConstant';

// Rule delete button
export function getRenderRuleDeleteButton(
  deleteEntity,
  apiEndpoint,
  pageType,
  checkPermission,
  userDetails,
  t
) {
  return function renderRuleDeleteButton(rule) {
    const hasPermission =
      checkPermission(PrivateRouteConst.RULES_DELETE) ||
      (checkPermission(PrivateRouteConst.SELF_RULES_DELETE) &&
        rule?.created_by === userDetails?.unique_id);

    if (!hasPermission) return null;

    return (
      <Popconfirm
        title={
          rule?.used_in_unification_calculation
            ? t('rules.messages.deactivateRule')
            : t('rules.messages.deleteRule')
        }
        okText={
          rule?.used_in_unification_calculation
            ? t('buttons.deactivate')
            : t('buttons.delete')
        }
        okType="danger"
        onCancel={(e) => {
          e?.stopPropagation();
          e?.preventDefault();
        }}
        onConfirm={(e) => {
          e?.stopPropagation();
          e?.preventDefault();
          deleteEntity(apiEndpoint.rulesDraft, rule.unique_id);
        }}
      >
        <Button
          danger
          type="text"
          icon={<DeleteOutlined style={{ fontSize: 20 }} />}
          className="a8-delete-button"
          disabled={pageType === 'Show' || !rule?.rule_is_active}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </Popconfirm>
    );
  };
}

// Rule group delete button
export function getRenderRuleGroupDeleteButton(
  deleteEntity,
  apiEndpoint,
  pageType,
  checkPermission,
  userDetails,
  t
) {
  return function renderRuleGroupDeleteButton(group) {
    const hasPermission =
      checkPermission(PrivateRouteConst.RULE_GROUPS_DELETE) ||
      (checkPermission(PrivateRouteConst.SELF_RULE_GROUPS_DELETE) &&
        group?.created_by === userDetails?.unique_id);

    if (!hasPermission) return null;

    return (
      <Popconfirm
        title={
          group?.used_in_unification_calculation
            ? t('ruleGroup.messages.deactivateRuleGroup')
            : t('ruleGroup.messages.deleteRuleGroup')
        }
        okText={
          group?.used_in_unification_calculation
            ? t('buttons.deactivate')
            : t('buttons.delete')
        }
        okType="danger"
        onCancel={(e) => {
          e?.stopPropagation();
          e?.preventDefault();
        }}
        onConfirm={(e) => {
          e?.stopPropagation();
          e?.preventDefault();
          deleteEntity(apiEndpoint.ruleGroupDraft, group.unique_id);
        }}
      >
        <Button
          danger
          type="text"
          icon={<DeleteOutlined style={{ fontSize: 24 }} />}
          className="a8-delete-button"
          disabled={pageType === 'Show' || !group?.rule_group_is_active}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </Popconfirm>
    );
  };
}

// Rule copy button
export function getRenderCopyButton(onCopyClick, pageType, checkPermission) {
  return function renderCopyButton(rule) {
    const hasPermission = checkPermission(PrivateRouteConst.RULE_PLANS_DELETE);
    if (!hasPermission) return null;

    return (
      <Button
        type="text"
        icon={<CopyOutlined style={{ fontSize: 20 }} />}
        className="a8-edit-button"
        disabled={pageType === 'Show'}
        onClick={() => onCopyClick(rule)}
      />
    );
  };
}
